import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path === '/trading' || to.path === '/trading-chart' || to.path === '/trading-test') {
    document.title = "Demo Trading";
  }
  next();
});
export default router;
